var _defs, _rect, _rect2, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFormalogosvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    zoomAndPan: "magnify",
    viewBox: "0 0 300 299.999988",
    height: 400,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7d746217c6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 58.121094 0 L 132.367188 0 L 132.367188 300 L 58.121094 300 Z M 58.121094 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a1daf66483"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.121094 0 L 74.367188 0 L 74.367188 300 L 0.121094 300 Z M 0.121094 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa61c446f2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 75,
    y: 0,
    height: 300
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "84538a2a0b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 132.367188 122.621094 L 254.996094 122.621094 L 254.996094 196.867188 L 132.367188 196.867188 Z M 132.367188 122.621094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "96eb45fb42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.367188 0.621094 L 122.996094 0.621094 L 122.996094 74.867188 L 0.367188 74.867188 Z M 0.367188 0.621094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fb0ff1cf3b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 123,
    y: 0,
    height: 75
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ff30778653"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 132.367188 0 L 300 0 L 300 74.238281 L 132.367188 74.238281 Z M 132.367188 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1e6ece75ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.367188 0 L 168 0 L 168 74.238281 L 0.367188 74.238281 Z M 0.367188 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "712e902fe3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 168,
    y: 0,
    height: 75
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -30,
    width: 360,
    fill: "#ffffff",
    y: -29.999999,
    height: 359.999986,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -30,
    width: 360,
    fill: "#000000",
    y: -29.999999,
    height: 359.999986,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7d746217c6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 58, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aa61c446f2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a1daf66483)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 74.367188 0 L 74.367188 308.578125 L 0.121094 308.578125 L 0.121094 0 Z M 74.367188 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#84538a2a0b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132, 122)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fb0ff1cf3b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#96eb45fb42)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 122.996094 74.867188 L 0.320312 74.867188 L 0.320312 0.621094 L 122.996094 0.621094 Z M 122.996094 74.867188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ff30778653)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#712e902fe3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1e6ece75ac)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 178.496094 74.238281 L 0.425781 74.238281 L 0.425781 -0.0078125 L 178.496094 -0.0078125 Z M 178.496094 74.238281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormalogosvg);
export default __webpack_public_path__ + "static/media/formalogosvg.ea841fb404debf77e42d08a68138a6bf.svg";
export { ForwardRef as ReactComponent };